// @flow

import type { EasyAction } from '../../type'

import * as React from 'react'

type Props = {
  convertId: string
};

export default class Toutiao extends React.PureComponent<Props> {
  static actions: EasyAction[] = [
    {
      title: '记录注册事件',
      name: 'pushEvent'
    }
  ];

  componentWillMount () {
    loadToutiaoAd()
  }

  actionPushEvent = (data: void, dynamicData: { convertId: string }) => {
    if (window._taq) {
      window._taq.push({
        convert_id: dynamicData.convertId,
        event_type: 'form'
      })
    }
  };

  render () {
    return null
  }
}

function loadToutiaoAd () {
  /* eslint-disable */
  (function(root) {
    root._tt_config = true;
    var ta = document.createElement('script');
    ta.type = 'text/javascript';
    ta.async = true;
    ta.src =
      'https://s3.pstatp.com/bytecom/resource/track_log/src/toutiao-track-log.js';
    var s = document.getElementsByTagName('script')[0];
    // $FlowFixMe
    s.parentNode.insertBefore(ta, s);
    /* eslint-enable */
  })(window)
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/plugin/Toutiao.js